import { ElementRef, Injectable, SimpleChanges } from '@angular/core';
import { LoginAuthUserInputFields } from '@com-delta-idp/mnx-login-ui';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { LoginModalHelperSuperSupportComponent } from './login-modal-helper-super-support.component';

@Injectable({
  providedIn: 'root'
})
export class LoginModalHelperSuperComponent extends LoginModalHelperSuperSupportComponent {
  setModalPositionHelper(loginModalNativeElement: ElementRef) {
    const alertAdvisoryContainer =
      document.querySelector('.alert-advisory-main-container')?.scrollHeight ??
      0;
    const heightNavContainer = this.getHeaderPosition();
    let totalHeight = alertAdvisoryContainer + heightNavContainer;
    const loginModalEl = loginModalNativeElement;
    if (this.innerWidth <= 767) {
      totalHeight = 0;
      this.renderer.setStyle(loginModalEl, 'top', 0 + 'px');
    } else {
      this.renderer.setStyle(loginModalEl, 'top', totalHeight + 'px');
    }
    this.totalHeight = totalHeight;
  }

  getHeaderPosition(): number {
    return (
      this.document.querySelector('.navbar')?.scrollHeight ??
      (0 || this.document.querySelector('.header-container')?.scrollHeight) ??
      0
    );
  }

  toggleBackdropHelper() {
    const loginModalDiv = document.querySelector('.login-modal-container');
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      this.showBackDrop = false;
    } else {
      this.showBackDrop = true;
    }
  }

  checkForWarmStateLoginInput(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes.checkOutWarmState &&
      changes.checkOutWarmState.currentValue
    );
  }

  checkForDisplayLoginInput(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes.displayLoginModal &&
      changes.displayLoginModal.currentValue
    );
  }

  handleTabKey(e: KeyboardEvent, modelId: string, tagsList: string) {
    if (e.key === 'Tab') {
      const focusable = this.elementRef.nativeElement
        .querySelector(modelId)
        .querySelectorAll(tagsList);
      if (focusable.length) {
        this.focusTab(focusable, e);
      }
    }
  }

  toggleModalHelper() {
    const loginModalDiv = document.querySelector('.login-modal-container');
    const body = document.body;
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      loginModalDiv.classList.remove('d-none');
      this.displayNextScreen(VIEW_NAME.LOGIN_CREDENTIALS_SCREEN);
      this.resetPasswordFacade.resetForm();
    } else {
      if (this.loadSpinner) {
        return;
      }
      loginModalDiv?.classList.add('d-none');
      this.renderer.removeClass(body, 'modal-open');
      this.facade.resetForm();
      this.facade?.formAlertDisplay();
      this.focusLoginHeaderButton();
    }
  }

  formAlertDisplay() {
    this.facade.formAlertDisplay();
  }

  fieldFocusChange(field: string) {
    this.facade.focusChange(field);
  }

  inputChange() {
    this.facade.formValueChange();
  }

  isLastNameEnabled(booleanValue: boolean) {
    this.lastNameField = booleanValue;
  }

  resetPasswordFormFieldFocusChange(field: string) {
    this.resetPasswordFacade.resetPasswordFormFocusChange(field);
  }

  resetPasswordFormInputChange(field: string) {
    this.resetPasswordFacade.resetPasswordFormValueChange(field);
  }

  onResetPasswordFormSubmit(): void {
    this.resetPasswordFacade.onResetPasswordFormSubmit(true);
  }

  onFormSubmit(userInputFields: LoginAuthUserInputFields): void {
    this.facade.onFormSubmit(true, userInputFields);
  }

  forgotLoginInputChange() {
    this.forgotLoginFacade.forgotLoginformValueChange();
  }

  closeOverLayMessage() {
    this.forgotLoginFacade.closeOverLayMessage();
  }

  forgotLoginFormSubmit(): void {
    this.forgotLoginFacade.onForgotLoginFormSubmit(true);
  }

  forgotLoginFieldFocusOut(field: string) {
    this.forgotLoginFacade.focusChangeForgotLogin(field);
  }

  focusLoginHeaderButton() {
    const loginHeaderButton = document.getElementById('login-modal-button');
    loginHeaderButton?.focus();
  }
}
